import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-200 font-["Raleway"] uppercase tracking-[0.1em]';
  const variants = {
    primary: 'bg-[#1A1A1A] text-[#D4A853] hover:bg-[#2D2D2D]',
    secondary: 'bg-[#D4A853] text-[#1A1A1A] hover:bg-[#E8C97A]',
    outline: 'border border-[#1A1A1A] text-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-white',
    ghost: 'text-[#1A1A1A] hover:text-[#D4A853]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-xs',
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-sm'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-482">
      {children}
    </button>;
}